import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CustomTextField } from '../CustomComponents/CustomTextField';
import { InlineEditableField } from 'app/components/Common/EditPage/InlineEditableField';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditStatus, selectPageAttributes } from '../store/placementPageAttributes.selector';
import { pageAttributesActions } from '../store/placementPageAttributes.redux';
import { editableFields } from '../../editUtils';
import { selectEditableData } from '../../../../../../store/redux-store/placement-details/selectors';
import { ActionAccessorHook } from './ActionAccessorHook';

export const SellingPoints = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { control, watch } = useFormContext();
  const { sellingPoints: status } = useSelector(selectEditStatus);
  const { editOrderStack } = useSelector(selectPageAttributes);
  const { sellingPoints: defaultValue } = useSelector(selectEditableData);

  const undoChecker = () => !editOrderStack.some(key => key === 'sellingPoints');

  /** value spread from render params is overwriting from unknown source - resolved employing a watch */
  const value = watch('sellingPoints');

  return (
    <Controller
      control={control}
      name="sellingPoints"
      render={({ field: { onChange, ...rest } }) => (
        <div>
          {/** Component is used to access inaccessible methods from react-hook-form Controller
           * to invoke actions - say undo action */}
          <ActionAccessorHook
            actionChecker={undoChecker}
            accessAction={() => onChange(defaultValue)}
            hookDependancies={[editOrderStack]}
          />
          <InlineEditableField
            {...rest}
            id={id}
            label={value}
            inputProps={{ value, minWidth: 80, multiline: true, renderedFromInlineEditor: true }}
            Control={CustomTextField}
            onChange={newValue => {
              onChange(newValue);
              dispatch(pageAttributesActions.pushToEditOrderStack(editableFields.sellingPoints));
            }}
            alignStart
            tooltipText={status.disabled ? t('placement.profile.edit.disableText') : ''}
            setCurrentFocus={state => dispatch(pageAttributesActions.setCurrentFocus(state !== null ? id : null))}
            {...status}
          />
        </div>
      )}
    />
  );
};
